import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
}

export const LockIcon: React.FC<IProps> = props => {
	const { className, fillColor } = props;
	return (
		<SvgIcon className={`lock-icon ${className || ''}`} height={14} width={12}>
			<g fill={fillColor || '#858789'} fillRule='evenodd'>
				<path d='M9.6,5.6 L9.6,3.8 C9.6,1.7013441 7.8986559,0 5.8,0 C3.7013441,0 2,1.7013441 2,3.8 L2,5.6 L1.4,5.6 C0.6268014,5.6 0,6.2268014 0,7 L0,12.6 C0,13.3731986 0.6268014,14 1.4,14 L10.2,14 C10.9731986,14 11.6,13.3731986 11.6,12.6 L11.6,7 C11.6,6.2268014 10.9731986,5.6 10.2,5.6 L9.6,5.6 Z M3.4,3.8 C3.4,2.4744931 4.4744931,1.4 5.8,1.4 C7.1255069,1.4 8.2,2.4744931 8.2,3.8 L8.2,5.6 L3.4,5.6 L3.4,3.8 Z M6.5,9.8 C6.5,10.1865993 6.1865993,10.5 5.8,10.5 C5.4134007,10.5 5.1,10.1865993 5.1,9.8 C5.1,9.4134007 5.4134007,9.1 5.8,9.1 C6.1865993,9.1 6.5,9.4134007 6.5,9.8 Z' />
			</g>
		</SvgIcon>
	);
};
